var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import { Body } from 'syf-component-library/ui/typography';
import triggerAnalyticsEvent, { Analytics } from '../../../../helpers/analyticsMiddleware';
import Section from '../../../../ui/atoms/Section';
import { t } from '../../../../strings/i18n/i18n';
import DisputesImage from '../../../../ui/atoms/DisputesImage';
import { shallowEqual, useSelector } from 'react-redux';
import styled from 'styled-components';
import { spacing } from 'syf-component-library/defaultTheme';
import useWindowSize from 'syf-component-library/ui/customHooks/useWindowWidth';
import { MoreInfoImageContainer } from '../Start/subcomponents';
var Container = styled(Section)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n"], ["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n"])));
var Content = styled(Body)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  text-align: center;\n  margin-top: ", "px;\n"], ["\n  text-align: center;\n  margin-top: ", "px;\n"])), spacing.small);
var Exit = function () {
    var assetsURL = useSelector(function (state) { return state; }, shallowEqual).mfeConfig.assetsURL;
    var isLessThanTablet = useWindowSize().isLessThanTablet;
    var imageSize = isLessThanTablet ? 'xsmall' : 'small';
    useEffect(function () {
        triggerAnalyticsEvent({
            PageKind: Analytics.Dispute,
            PageFunction: Analytics.Billing,
            PageSubFunction: Analytics.Form,
            pageName: Analytics.CompleteFailure
        });
    }, []);
    return (_jsxs(Container, { children: [_jsx(MoreInfoImageContainer, { children: _jsx(DisputesImage, { assetsHost: assetsURL, imageName: "MORE_INFO", size: imageSize }) }), _jsx("h2", { children: t('exit.title') }), _jsx(Content, { children: t('exit.description') })] }));
};
export default Exit;
var templateObject_1, templateObject_2;
//# sourceMappingURL=index.js.map